module.exports = __webpack_public_path__ + "img/fаlag-ukr.fa4f8946.svg";